module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui left rail hideOnMobileSite",
    staticStyle: {
      "left": "20px",
      "z-index": "1"
    }
  }, [_c('div', {
    staticClass: "ui xstickyx"
  }, [_c('div', {
    staticClass: "ui list"
  }, _vm._l((_vm.wdInfo), function(i) {
    return (_vm.isMenuEntryVisible(i.id)) ? _c('a', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.scrollTo(i.id)
        }
      }
    }, [(_vm.wdNewErrorCounts[i.id] > 0) ? _c('i', {
      class: 'large ' + i.icon + ' icon',
      style: ('padding:' + i.padding + ';color:brown;position:relative;')
    }, [_c('div', [_vm._v(_vm._s(_vm.wdNewErrorCounts[i.id]))])]) : _c('i', {
      class: 'large ' + i.icon + ' icon',
      style: ('padding:' + i.padding + ';color:grey;')
    }), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "header"
    }, [_vm._v(_vm._s(i.name))])])]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.wdMenuUpdateTrigger))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cfeec1b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WatchdogMenu.vue
// module id = 723
// module chunks = 2